/* Hayati Essence V10: functional collection filtering for the current catalogue. */
(function(){
'use strict';
var root=document.querySelector('[data-v10-collection]');if(!root)return;
var form=root.querySelector('[data-v10-filters]'),grid=root.querySelector('[data-v10-grid]');
if(!form||!grid)return;
var cards=Array.prototype.slice.call(grid.querySelectorAll('[data-v10-card]'));
var output=Array.prototype.slice.call(root.querySelectorAll('[data-v10-count]'));
var empty=root.querySelector('[data-v10-empty]'),active=root.querySelector('[data-v10-active]');
var panel=root.querySelector('#he-v10-filters'),opener=root.querySelector('[data-v10-filter-open]');
var overlay=root.querySelector('.he-v10-filter-overlay'),previousFocus=null;
function selected(name){return Array.prototype.slice.call(form.querySelectorAll('input[name="'+name+'"]:checked')).map(function(el){return el.value.toLowerCase()})}
function priceField(n){var e=form.querySelector('input[name="'+n+'"]');return e&&e.value!==''?Number(e.value):null}
function check(card,n,values){if(!values.length)return true;var v=(card.dataset[n]||'').toLowerCase();return values.some(function(x){return n==='sizes'?v.indexOf('|'+x+'|')!==-1:v===x||n==='character'&&v.indexOf(x)!==-1})}
function changed(){var options=Array.prototype.slice.call(form.querySelectorAll('input[type="checkbox"]:checked'));return options.length>0||priceField('min')!==null||priceField('max')!==null}
function apply(save){
var types=selected('type'),family=selected('family'),character=selected('character'),sizes=selected('size'),stock=selected('in_stock').length>0,min=priceField('min'),max=priceField('max');
var count=0;
cards.forEach(function(c){
 var price=Number(c.dataset.price||0)/100;
 var show=check(c,'category',types)&&check(c,'family',family)&&check(c,'character',character)&&check(c,'sizes',sizes)&&(!stock||c.dataset.available==='yes')&&(min===null||price>=min)&&(max===null||price<=max);
 c.hidden=!show;
 if(show)count++;
});
output.forEach(function(e){e.textContent=count});
if(empty)empty.hidden=count!==0;
if(active)active.hidden=!changed();
if(save&&window.history&&window.history.replaceState){
 var u=new URL(window.location.href);
 ['v10_type','v10_family','v10_character','v10_size','v10_stock','v10_min','v10_max'].forEach(function(k){u.searchParams.delete(k)});
 [['type',types],['family',family],['character',character],['size',sizes]].forEach(function(pair){pair[1].forEach(function(x){u.searchParams.append('v10_'+pair[0],x)})});
 if(stock)u.searchParams.set('v10_stock','yes');
 if(min!==null)u.searchParams.set('v10_min',String(min));
 if(max!==null)u.searchParams.set('v10_max',String(max));
 window.history.replaceState(null,'',u.pathname+u.search);
}
}
function openPanel(){
 if(!panel)return;
 previousFocus=document.activeElement;
 panel.classList.add('is-open');
 document.body.classList.add('he-v10-filter-open');
 if(overlay)overlay.hidden=false;
 if(opener)opener.setAttribute('aria-expanded','true');
 var focus=panel.querySelector('[data-v10-filter-close]');
 if(focus)focus.focus();
}
function closePanel(){
 if(!panel)return;
 panel.classList.remove('is-open');
 document.body.classList.remove('he-v10-filter-open');
 if(overlay)overlay.hidden=true;
 if(opener)opener.setAttribute('aria-expanded','false');
 if(previousFocus&&previousFocus.focus)previousFocus.focus();
}
if(opener)opener.addEventListener('click',openPanel);
root.querySelectorAll('[data-v10-filter-close]').forEach(function(e){e.addEventListener('click',closePanel)});
document.addEventListener('keydown',function(e){if(e.key==='Escape'&&panel&&panel.classList.contains('is-open'))closePanel()});
form.addEventListener('change',function(){apply(true)});
form.addEventListener('input',function(e){if(e.target.matches('input[type="number"]'))apply(true)});
form.addEventListener('submit',function(e){e.preventDefault();apply(true);closePanel()});
form.addEventListener('reset',function(){window.requestAnimationFrame(function(){apply(true)})});
root.querySelectorAll('[data-v10-apply]').forEach(function(b){b.addEventListener('click',function(){apply(true);closePanel()})});
root.querySelectorAll('[data-v10-clear]').forEach(function(b){b.addEventListener('click',function(){form.reset();apply(true);closePanel()})});
try{
 var url=new URL(window.location.href),map={type:'v10_type',family:'v10_family',character:'v10_character',size:'v10_size'};
 Object.keys(map).forEach(function(k){url.searchParams.getAll(map[k]).forEach(function(val){form.querySelectorAll('input[name="'+k+'"]').forEach(function(e){if(e.value===val)e.checked=true})})});
 if(url.searchParams.get('v10_stock')==='yes')form.querySelector('input[name="in_stock"]').checked=true;
 ['min','max'].forEach(function(k){var val=url.searchParams.get('v10_'+k);if(val!==null)form.querySelector('input[name="'+k+'"]').value=val});
}catch(e){}
function initAvailableOptions(){
  var all=Array.prototype.slice.call(form.querySelectorAll('input[type="checkbox"]'));
  all.forEach(function(inp){
    var n=inp.name,v=inp.value.toLowerCase();
    var available=cards.some(function(c){
      if(n==='type')return c.dataset.category===v;
      if(n==='family')return c.dataset.family===v;
      if(n==='character')return (c.dataset.character||'').indexOf(v)!==-1;
      if(n==='size')return (c.dataset.sizes||'').indexOf('|'+v+'|')!==-1;
      if(n==='in_stock')return c.dataset.available==='yes';
      return true;
    });
    if(!available){inp.disabled=true;var label=inp.closest('label');if(label)label.hidden=true;}
  });
  form.querySelectorAll('fieldset').forEach(function(group){if(!group.querySelector('label:not([hidden])'))group.hidden=true;});
}
initAvailableOptions();
apply(false);
})();